export default {"src":"/_next/static/media/mixed-icon.a7ee56fb.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};